export default __webpack_public_path__ + "static/banner-renovation-new-floor-27ce975be99686a61c9c42f7edb8863e.jpg";